import { render, staticRenderFns } from "./AdminSys.vue?vue&type=template&id=7c553cd4"
import script from "./AdminSys.vue?vue&type=script&lang=js"
export * from "./AdminSys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports